<template>
    <b-modal id="adjustment_delete" ref="adjustment_delete" header-class="no-border" footer-class="no-border"
             @hidden="$emit('close')"
             :title="'Delete ' + this.adjustment.data.attributes.item + '?'">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('adjustment_delete')" v-text="'Cancel'"/>

            <state-button size="sm" variant="danger" :click="deleteAdjustment">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../../components/Common/StateButton";

export default {
    name: "AdjustmentDeleteModal",

    components: {
        StateButton,
    },

    props: [
        'adjustment'
    ],

    methods: {
        hideModal(refname) {
            this.$refs[refname].hide();
        },

        deleteAdjustment() {
            return new Promise((success, fail) => {
                this.$store.dispatch('deleteAdjustment', this.adjustment)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('deleted-adjustment');

                            this.$notify('error filled', 'Success!', 'Deleted the adjustment!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('adjustment_delete');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
